import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { AgentService } from 'src/app/services/agent.service';

@Component({
  selector: 'app-cash-off',
  templateUrl: './cash-off.component.html',
  styleUrls: ['./cash-off.component.css']
})
export class CashOffComponent implements OnInit {

  isCompleted: boolean = false;

  cashoffForm = this.fb.group({
    agentId: [this.item.agent.id, Validators.required],
    cashoffSum: [0, [Validators.required, Validators.min(1)]],
    comment: ""
  });

  constructor(@Inject(MAT_DIALOG_DATA) public item: any,
    private fb: FormBuilder,
    public snackBar: MatSnackBar,
    private translate: TranslateService,
    private agentSrv: AgentService,
  ) { }

  ngOnInit(): void {
      this.isCompleted = true;
  }

  // convenience getter for easy access to form fields
  get f() { return this.cashoffForm.controls; }
  public hasError = (controlName: string, errorName: string) => {
    return this.cashoffForm.controls[controlName].hasError(errorName);
  }

  public update = (form) => {
    if (this.cashoffForm.valid) {
      this.execute(form);
    }
  }

  private execute = (data) => {
    let json: any = {
      amount: Math.round((Number(Number(data.cashoffSum).toFixed(2)) * 100)),
      comment: data.comment
    }

    this.agentSrv.cashOff(json, data.agentId)
      .subscribe(
        data => {
          let message = this.translate.instant('success-cashoff-agent');
          this.openSnackBar(message, 'x');
        },
        error => {
          if (error.status === 404 || error.status === 400) {
            let message = error.error;
            this.openSnackBar(message, 'x');
          }
          else if (error.status === 409) {
            let message = this.translate.instant('an-error-occurred-while-processing');
            this.openSnackBar(message, 'x');
          }
          else{
              if (error.status === 500) {
                let message = this.translate.instant('service-is-temporarily-unavailable');
                this.openSnackBar(message, 'x');
              }
              else {
                let message = this.translate.instant('an-error-occurred-while-processing');
                this.openSnackBar(message, 'x');
              }
          }
        }
      );
  }


  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 5000,
    });
  }

}
